<template>
  <SectionSplit
    class="Meeting2026Reconvened"
    src="../../assets/landing-finances/2026-meeting-reconvented-after.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.Meeting2026Reconvened {
  .Splitter-body {
    max-width: 50rem;
  }

  .body {
    padding: 2rem 0;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Reconvened Meeting of Sun Investment Group Bondholders",
    "paragraphs": [
      "On 28 May 2026, Sun Investment Group, UAB held a reconvened meeting of bondholders (ISIN code LT0000409963). The meeting resolved to extend the deadline for publishing the company’s audited consolidated and stand-alone annual financial statements for 2025 to 30 June 2026.<br><br>For more details, see the official announcement: <a href=\"https://view.news.eu.nasdaq.com/view?id=1445146&lang=en\" target=\"_blank\">Reconvened Meeting of Sun Investment Group Bondholders</a>"    ]
  },
  "lt": {
    "title": "Sun Investment Group obligacijų savininkų pakartotinis susirinkimas",
    "paragraphs": [
      "2026 m. gegužės 28 d. įvyko Sun Investment Group, UAB obligacijų (ISIN kodas LT0000409963) savininkų pakartotinis susirinkimas. Jame nutarta pratęsti metinių audituotų konsoliduotų ir atskirų finansinių ataskaitų už 2025 m. pateikimo terminą iki 2026 m. birželio 30 d.<br><br>Plačiau apie susirinkimą galima skaityti čia: <a href=\"https://view.news.eu.nasdaq.com/view?id=1445146&lang=lt\" target=\"_blank\">Sun Investment Group obligacijų savininkų pakartotinis susirinkimas</a>"
    ]
  }
}
</i18n>
